<template>
    <div>
      <official-fee-list></official-fee-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>